import { capitalizeWordsDirective } from '@utils/directives';

export default ({ app }) => {
  app.use(capitalizeWordsDirective);
};
